export const hotTextEditInfo = {
    editExcludeFields: []
}